import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { httpOptions } from 'src/app/global/global_variables';
import { DocksModel } from 'src/app/models/DocksModel';
import { TrucksExpModel } from 'src/app/models/TrucksExpModel';
import { catchError, concatMap, EMPTY, Observable, of, take } from 'rxjs';
import { formatDate } from '@angular/common';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import {
  TimeTableModel
} from '../../../models/TimeTableModel';
import { QueuesService } from 'src/app/services/queues/queues.service';
import { ExpeditionResponse } from 'src/app/models/ExpeditionResponse';
import { ExpeditionService } from 'src/app/services/expedition/expedition.service';
import { environment } from 'src/environments/environment';
import { TripResponse } from 'src/app/models/TripResponse';

@Component({
  selector: 'app-view-exp',
  templateUrl: './view-exp.component.html',
  styleUrls: ['./view-exp.component.css'],
})
export class ViewExpComponent implements OnInit {

  // UI controls
  @Output() refresh = new EventEmitter();
  status: boolean = true;
  docksOption$?: Observable<DocksModel[]>;
  config = false;
  faFilter = faFilter;

  // Data
  expeditionTripsData: ExpeditionResponse[] = [];
  expeditionDocks: DocksModel[] = [];
  expeditionData: TrucksExpModel[] = []
  timeTableData: TimeTableModel[] = [];
  selectedDock: DocksModel | any;
  Date = Date.now();

  // variables
  dateInterval: any;
  saidaReal: any;
  updateInterval: any;
  apiLink = environment.apiLink;
  httpOptions = httpOptions;
  takt: string = '';

  //Colors
  private readonly STANDART: string = '#FFF'
  private readonly GREENLIGHT: string = '#3CB371'
  private readonly YELLOWLIGHT: string = '#F1C21B'
  private readonly REDLIGHT: string = '#FF2340'

  public dock: number = 0;
  public dockId: number = 0;
  public bgColor: string = this.STANDART;
  public statusDock: string = this.STANDART;
  public ftColor: string = '';
  public trip: any;

  nextTrip: TripResponse | undefined | null
  activeTrip!: TripResponse | undefined | null
  ExtraTrip: boolean = false;

  constructor(
    private readonly queuesService: QueuesService,
    private readonly expService: ExpeditionService) { }

  ngOnInit() {
    this.docksOption$ = this.queuesService.getDockDetails();
    this.updateData();
    this.dateInterval = setInterval(() => {
      this.Date = Date.now();
      this.timer();
      const selectedRow = this.expeditionData.find(row => row.dock === this.selectedDock.id);
      console.log(selectedRow)
      if (this.shouldUpdateDockInfoToActiveTrip()) {
        this.updateDockInfoToActiveTrip();
        this.updateTripInfo(this.activeTrip!, this.selectedDock)
      }
    }, 1000);
    this.updateInterval = setInterval(() => {
      this.updateData();
      this.refreshQueue();
      
    }, 5000);
  }

  updateData(): void {
    this.expService.getTimeTableDataView().pipe
      (take(1),
        catchError(() => {
          return of([])
        })
      ).subscribe(
        (data: TimeTableModel[]) => {
          this.timeTableData = data
        }
      )

    this.expService.getExpeditionTableDataView().pipe
      (take(1),
        catchError(() => {
          return of({ trucks: [], docks: [] })
        })
      ).subscribe(
        (response) => {
          this.expeditionData = response.trucks
          this.expeditionDocks = response.docks.map(d => ({
            ...d,
            status: new Date(d.status + 'Z')
          }));
        }
      )
    if (this.selectedDock && this.expeditionDocks.some(d => d.id === this.selectedDock.id)) {
      this.selectedDock = this.expeditionDocks.find(d => d.id === this.selectedDock.id);
    }
  }

  updateTripInfo(activeTrip: TripResponse, selectedDock: any) {

    const agora = new Date();
    const [hora, minuto] = activeTrip.saidaLCB.split(':');
    const horaPrevista = new Date();
    const dataReal = new Date(selectedDock.status);
    const dataPrevista = new Date();

    horaPrevista.setHours(Number(hora), Number(minuto), 0, 0);
    dataPrevista.setHours(Number(activeTrip.inicioLCB.split(':')[0]));
    dataPrevista.setMinutes(Number(activeTrip.inicioLCB.split(':')[1]));
    dataPrevista.setSeconds(60);

    let diferencaTempo = horaPrevista.getTime() - agora.getTime();
    let minutos = Math.floor(diferencaTempo / (1000 * 60));
    let segundos = Math.floor((diferencaTempo % (1000 * 60)) / 1000);
    let segundosString = this.formatarNumero(segundos.toString().replace('-', ''));

    const box_inicio_top = document.querySelector('.box-start-card-top') as HTMLElement;
    const box_inicio_bottom = document.querySelector('.box-start-card-bottom') as HTMLElement;
    const box_fim_top = document.querySelector('.box-finish-card-top') as HTMLElement;
    const box_fim_bottom = document.querySelector('.box-finish-card-bottom') as HTMLElement;

    // Ajusta minutos se forem negativos
    if (minutos < 0) minutos += 1;

    // Atualiza a cor das caixas de início
    if (dataReal > dataPrevista) {
      box_inicio_top.style.backgroundColor = this.REDLIGHT;
      box_inicio_bottom.style.backgroundColor = this.REDLIGHT;
    } else {
      box_inicio_top.style.backgroundColor = this.GREENLIGHT;
      box_inicio_bottom.style.backgroundColor = this.GREENLIGHT;
    }

    // Atualiza a cor das caixas de fim
    if (minutos < 0 || segundos < 0) {
      box_fim_top.style.backgroundColor = this.REDLIGHT;
      box_fim_bottom.style.backgroundColor = this.REDLIGHT;
    } else {
      box_fim_top.style.backgroundColor = this.GREENLIGHT;
      box_fim_bottom.style.backgroundColor = this.GREENLIGHT;
    }

    const resultado = this.converterMinutosParaHoras(minutos);
    minutos = resultado?.minutos;
    const horas = resultado?.horas;

    const minutosString = this.formatarNumero(minutos.toString().replace('-', ''));
    const horasString = this.formatarNumero(horas.toString().replace('-', ''));

    // Atualiza a saída real
    if (minutos < 0 || segundos < 0) {
      this.saidaReal = '-' + horasString + ':' + minutosString + ':' + segundosString;
    } else {
      this.saidaReal = horasString + ':' + minutosString + ':' + segundosString;
    }
  }

  timer() {
    if (!this.selectedDock) return
    if (this.shouldUpdateDockInfoToGetNextTrip()) {
      this.updateDockInfoToGetNextTrip();
    }
  }

  private shouldUpdateDockInfoToActiveTrip(): boolean {
    return this.selectedDock.truck == 1 && this.selectedDock.active == 1;
  }

  private shouldUpdateDockInfoToGetNextTrip(): boolean {
    return this.selectedDock.truck == 0 && this.selectedDock.active == 1;
  }

  private isExtraTrip(trip: any) {
    return trip.extra != null
  }

  updateDockInfoToActiveTrip() {
    this.expService.getActiveTrip(this.dockId).pipe(
      concatMap(activeTrip => {
        if (activeTrip.tripsInQueue.length > 0) {
          this.activeTrip = activeTrip.tripsInQueue[0];
          const currentTime = this.convertTimeStringToMs(this.formatTimeFromTimestamp(Date.now()));
          const statusTime = this.convertTimeStringToMs(this.formatTimeSensor(this.selectedDock?.status));

          if (this.isExtraTrip(this.activeTrip)) {
            this.handleExtraTrip(currentTime, statusTime, this.activeTrip.extra!);
          } else {
            this.handleRegularTrip(currentTime, statusTime, this.activeTrip);
          }
          return EMPTY;
        } else {
          return this.expService.getNextTripInQueue(this.dockId).pipe(
            concatMap(nextTrip => {
              if (nextTrip.tripsInQueue.length > 0 && this.checkExpeditionTrucksDatabase(this.dockId)) {
                this.nextTrip = nextTrip.tripsInQueue[0];
                return this.expService.updateTripsStatus(this.nextTrip.viagem, 1)
              }
              return EMPTY;
            })
          );
        }
      })
    ).subscribe();
  }


  checkExpeditionTrucksDatabase(dockId: number): boolean {
    if (dockId <= 0 || dockId == null) return false;

    const registeredTripToCompare = this.expeditionData
      .filter(lineData => {
        return lineData.dock == dockId
      })

    return registeredTripToCompare.length > 0
  }

  checkInterval(statusTime: string, currentTime: string): boolean {
    const diffBetweenInAndOut = this.calculateDifferenceInMinutes(statusTime, currentTime)
    if (isNaN(diffBetweenInAndOut)) {
      console.warn("Diferença inválida entre os horários: ", { statusTime, currentTime })
      return false
    }
    return diffBetweenInAndOut >= 10
  }

  handleExtraTrip(currentTime: number, statusTime: number, extraTimeString: string) {
    const extraTime = this.convertTimeStringToMs(extraTimeString)
    const delta = extraTime + statusTime - currentTime

    this.updateTaktDisplay(delta, extraTime)
  }

  handleRegularTrip(currentTime: number, statusTime: number, activeTrip: any) {
    const inicioLCB = this.convertTimeStringToMs(activeTrip.inicioLCB)
    const saidaLCB = this.convertTimeStringToMs(activeTrip.saidaLCB)
    const taktTime = this.convertTimeStringToMs(this.calculateDifference(activeTrip.inicioLCB, activeTrip.saidaLCB))

    const delta = this.calculateDelta(inicioLCB, saidaLCB, statusTime, currentTime, taktTime)

    this.updateTaktDisplay(delta, taktTime)
  }

  validateDockWithTripDock(tripDockId: number, selectedDockId: number) {
    return tripDockId === selectedDockId
  }

  checkDatabase(selectedDockId: number, expeditionData: TrucksExpModel[]): boolean {
    return expeditionData.some(row => row.dock === selectedDockId)
  }

  updateDockInfoToGetNextTrip() {

    if (!this.activeTrip || !this.validateDockWithTripDock(this.activeTrip.doca, this.dockId)) {
      this.getNextTripInQueue(this.dockId);
      return;
    }

    if (!this.checkDatabase(this.selectedDock.id, this.expeditionData)) {
      console.warn("Sem linha registrada no banco.");
      this.updateTripStatus(0);
      return;
    }

    const selectedRow = this.expeditionData.find(row => row.dock === this.selectedDock.id);
    const sensorTime = this.formatTimeSensor(String(new Date(selectedRow!.arrival + 'Z')));
    const currentTime = this.formatTimeFromTimestamp(this.Date);

    if (this.checkInterval(sensorTime, currentTime)) {
      this.updateTripAndSave(2);
    } else {
      this.updateTripStatus(0);
    }
  }

  private updateTripStatus(status: number) {
    this.expService.updateTripsStatus(this.activeTrip!.viagem, status).subscribe();
  }

  private updateTripAndSave(status: number) {
    this.expService.updateTripsStatus(this.activeTrip!.viagem, status).pipe(
      concatMap(() => this.expService.saveOnExpeditionTrucksDatabase(this.dockId, this.activeTrip!.viagem))
    ).subscribe({
      next: () => {
        console.log(`Viagem ${this.activeTrip!.viagem} atualizada e salva no banco com sucesso.`);
      },
      error: (err) => {
        console.error(`Erro ao processar viagem ${this.activeTrip!.viagem}:`, err);
      }
    });
  }


  refreshQueue() {
    if (this.dockId == 0) {
      return;
    }
    this.expService.getActiveTrip(this.dockId).subscribe({
      next:
        (filteredTrip) => {
          this.activeTrip = filteredTrip.tripsInQueue.length > 0 ? filteredTrip.tripsInQueue[0] : null
          this.getNextTripInQueue(this.dockId)
        },
      error: (err) => {
        console.error('Erro ao buscar viagem ativa:', err);
      }
    });
  }


  calculateDelta(inicioLCBTime: number,
    saidaLCBTime: number,
    statusTime: number,
    currentTime: number,
    taktTime: number
  ): number {
    return taktTime + statusTime - currentTime
  }

  updateTaktDisplay(delta: number, taktTime: number) {
    this.takt = formatDate(Math.abs(delta), 'HH:mm:ss', 'en-US', 'UTC');

    if (delta < 0) {
      this.bgColor = this.REDLIGHT;
      this.takt = '-' + this.takt;
    } else if (delta < taktTime / 3) {
      this.bgColor = this.YELLOWLIGHT;
    } else {
      this.bgColor = this.GREENLIGHT;
    }
  }

  changeDock(docks: number): void {

    this.selectedDock = this.expeditionDocks.find((d) => d.id == docks);
    this.dock = this.selectedDock.description;
    this.dockId = this.selectedDock.id;
  }

  //* -------------------------------------------- FILA DE VIAGENS -------------------------------------------- *//

  getNextTripInQueue(dockId: number): void {

    this.expService.getNextTripInQueue(dockId).subscribe({
      next: (response) => {
        if (response.tripsInQueue.length > 0) {
          this.nextTrip = response.tripsInQueue[0];
          this.bgColor = this.STANDART;
        } else {
          this.nextTrip = null;
        }
      },
      error: (err) => {
        console.error('Erro ao buscar a próxima viagem na fila:', err);
        this.nextTrip = null;
      }
    }
    );
  }

  //* -------------------------------------------- FORMATAÇÃO DE NÚMEROS -------------------------------------------- *//
  calculateDifference(start: string, end: string): string {

    const endTime = this.convertTimeStringToValidDate(end);
    const startTime = this.convertTimeStringToValidDate(start);

    if (!startTime || !endTime) return " "

    if (endTime.getTime() < startTime.getTime()) {
      // Adiciona 24 horas ao endTime se ele for menor que startTime
      endTime.setDate(endTime.getDate() + 1);
    }

    const diffInMs = endTime.getTime() - startTime.getTime();

    const diffInHours = Math.floor(diffInMs / (60 * 60 * 1000));
    const diffInMinutes = Math.floor((diffInMs % (60 * 60 * 1000)) / (60 * 1000));
    const diffInSeconds = Math.floor((diffInMs % (60 * 1000)) / 1000);

    const formattedHours = String(diffInHours).padStart(2, '0');
    const formattedMinutes = String(diffInMinutes).padStart(2, '0');
    const formattedSeconds = String(diffInSeconds).padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }

  calculateDifferenceInMinutes(statusTime: string, currentTime: string): number {
    if (!statusTime || !currentTime || !/^\d{1,2}:\d{2}(:\d{2})?$/.test(statusTime) || !/^\d{1,2}:\d{2}(:\d{2})?$/.test(currentTime)) {
      console.error('Horário inválido:', { statusTime, currentTime });
      return NaN;
    }

    // Realiza o split para obter horas, minutos e segundos (se disponíveis)
    const [statusHours, statusMinutes] = statusTime.split(':').map(Number);
    const [currentHours, currentMinutes, currentSeconds] = currentTime.split(':').map(Number);

    // Converte os dois horários para minutos totais
    const statusTotalMinutes = statusHours * 60 + statusMinutes;
    const currentTotalMinutes = currentHours * 60 + currentMinutes + (currentSeconds ? currentSeconds / 60 : 0);

    // Se o horário atual for menor que o statusTime, significa que houve uma virada de dia
    if (currentTotalMinutes < statusTotalMinutes) {
      // Adiciona 24 horas (1440 minutos) ao currentTotalMinutes para contabilizar a virada do dia
      return Math.floor((currentTotalMinutes + 1440) - statusTotalMinutes);
    } else {
      // Calcula a diferença normalmente se não houver virada de dia
      return Math.floor(currentTotalMinutes - statusTotalMinutes);
    }
  }

  convertTimeStringToValidDate(timeString: string): Date | null {
    if (!timeString) return null;

    const currentDate = new Date();
    const [hours, minutes, seconds] = timeString.split(":").map(Number);

    currentDate.setHours(hours);
    currentDate.setMinutes(minutes);
    currentDate.setSeconds(seconds || 0);
    currentDate.setMilliseconds(0);

    return currentDate;
  }

  convertTimeStringToMs(timeString: string): number {
    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    return ((hours * 60 + minutes) * 60 + (seconds || 0)) * 1000;
  }

  convertMsToTimeString(ms: number): string {
    let totalMinutes = Math.floor(ms / (1000 * 60));
    let hours = Math.floor(totalMinutes / 60);
    let minutes = totalMinutes % 60;

    let formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    return formattedTime;
  }

  formatTimeSensor(sensorTime: string): string {
    return new Date(sensorTime).toLocaleDateString('pt-BR', { hour: '2-digit', minute: '2-digit' }).substring(12);
  }

  formatTimeFromTimestamp(timestamp: number): string {
    let date = new Date(timestamp);

    let hours = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();

    let formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

    return formattedTime;
  }

  converterMinutosParaHoras(minutos: number) {
    const sinal = Math.sign(minutos); // Obtém o sinal dos minutos (1 para positivo, -1 para negativo, 0 para zero)

    // Converte para valor absoluto e realiza a conversão para horas e minutos
    const minutosAbs = Math.abs(minutos);
    const horas = Math.floor(minutosAbs / 60);
    const minutosRestantes = minutosAbs % 60;

    return {
      horas: sinal * horas,
      minutos: minutosRestantes,
    };
  }

  formatarNumero(numero: string) {
    return Number(numero) < 10 ? `0${numero}` : numero;
  }

  formatarData(dockTimeStamp: any) {

    // Obter os componentes da data no horário UTC
    const year = dockTimeStamp.getUTCFullYear();
    const month = String(dockTimeStamp.getUTCMonth() + 1).padStart(2, '0'); // getUTCMonth retorna de 0 a 11
    const day = String(dockTimeStamp.getUTCDate()).padStart(2, '0');
    const hours = String(dockTimeStamp.getUTCHours()).padStart(2, '0');
    const minutes = String(dockTimeStamp.getUTCMinutes()).padStart(2, '0');
    const seconds = String(dockTimeStamp.getUTCSeconds()).padStart(2, '0');

    // Montar a data no formato desejado
    const reformattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    return reformattedDate
  }
}

